/* Offline outbox using localStorage. Generic queue of pending requests. */
import { api } from "./api";

const KEY = "bc_outbox_v1";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}
function write(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function outboxCount() {
  return read().length;
}

export function enqueue(method, url, body) {
  const items = read();
  items.push({
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    method, url, body, createdAt: new Date().toISOString(),
  });
  write(items);
  window.dispatchEvent(new CustomEvent("bc-outbox-change"));
}

export async function flushOutbox() {
  if (!navigator.onLine) return { ok: false, reason: "offline" };
  const items = read();
  if (!items.length) return { ok: true, sent: 0 };
  const remaining = [];
  let sent = 0;
  for (const it of items) {
    try {
      await api.request({ method: it.method, url: it.url, data: it.body });
      sent += 1;
    } catch (e) {
      // keep the failed item for retry
      remaining.push(it);
    }
  }
  write(remaining);
  window.dispatchEvent(new CustomEvent("bc-outbox-change"));
  return { ok: true, sent, remaining: remaining.length };
}

/** Try posting; on failure, enqueue and return a mock response shape. */
export async function postOrQueue(url, body) {
  if (!navigator.onLine) {
    enqueue("POST", url, body);
    return { _queued: true, ...body };
  }
  try {
    const { data } = await api.post(url, body);
    return data;
  } catch (e) {
    // Server unreachable — queue it
    enqueue("POST", url, body);
    return { _queued: true, ...body };
  }
}
